/**
 * Vendens Product Slider & V-Card Logic
 * Handles native scrolling, drag-to-scroll, and variant-based price dynamic updates.
 */

// Format money helper (Customizable based on Shopify store currency formatting)
function formatMoneyTL(cents) {
    var normalized = cents;

    if (typeof normalized === 'string') {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
    }

    var parsed = Number(normalized);
    if (!Number.isFinite(parsed)) parsed = 0;

    return (parsed / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + ' TL';
}

function initVendensSlider(sectionId) {
    const section = document.getElementById(sectionId);
    if (!section) return;

    // Prevent duplicate bindings (theme editor re-renders / repeated init calls)
    if (section.dataset.vpsInit === 'true') return;
    section.dataset.vpsInit = 'true';

    // 3. Variant Handling inside the section
    const cards = section.querySelectorAll('.v-card');
    
    cards.forEach(card => {
        const swatches = card.querySelectorAll('.v-card__swatch');
        if (swatches.length === 0) return;

        const priceWas = card.querySelector('[data-price-was]');
        const priceNow = card.querySelector('[data-price-now]');
        const variantInput = card.querySelector('.v-card__variant-input');
        const popup = card.querySelector('.v-card__var-popup');
        const popupOpeners = card.querySelectorAll('[data-variant-popup-open]');
        const popupCloser = card.querySelector('[data-variant-popup-close]');
        const primaryImage = card.querySelector('.v-card__img--primary');
        const secondaryImage = card.querySelector('.v-card__img--secondary');

        const defaultPrimaryImage = card.getAttribute('data-default-primary-image') || '';
        const defaultSecondaryImage = card.getAttribute('data-default-secondary-image') || '';

        const openPopup = () => {
            if (!popup) return;
            popup.classList.add('v-is-open');
            popup.setAttribute('aria-hidden', 'false');
        };

        const closePopup = () => {
            if (!popup) return;
            popup.classList.remove('v-is-open');
            popup.setAttribute('aria-hidden', 'true');
        };

        popupOpeners.forEach(opener => {
            opener.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                openPopup();
            });
        });

        if (popupCloser) {
            popupCloser.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                closePopup();
            });
        }

        document.addEventListener('click', (e) => {
            if (!popup || !popup.classList.contains('v-is-open')) return;
            if (!card.contains(e.target)) {
                closePopup();
            }
        });

        // Metafield Discount Rules stored on the card
        const metafieldDiscountActive = card.getAttribute('data-discount-active') === 'true';
        const discountType = (card.getAttribute('data-discount-type') || '').toLowerCase();
        const discountValue = parseFloat(card.getAttribute('data-discount-value') || 0);
        const metafieldBadgeText = card.getAttribute('data-discount-badge-text') || '';

        const discountBadge = card.querySelector('.v-card__discount');

        const renderDiscountBadge = (badgeText) => {
            if (!discountBadge) return;

            if (!badgeText) {
                discountBadge.style.display = 'none';
                return;
            }

            discountBadge.style.display = 'flex';
            discountBadge.innerHTML = `${badgeText} <span class="v-card__discount-text">İndirim</span>`;
        };

        swatches.forEach(swatch => {
            swatch.addEventListener('click', (e) => {
                // Prevent event bubbling if clicking swatch triggers overlay link
                e.preventDefault();
                e.stopPropagation();

                // Update active states (inline + popup senkron)
                swatches.forEach(s => s.classList.remove('v-is-active'));
                const newVariantId = swatch.getAttribute('data-variant-id');
                if (!newVariantId) return;

                swatches.forEach(s => {
                    if (s.getAttribute('data-variant-id') === newVariantId) {
                        s.classList.add('v-is-active');
                    }
                });

                // Get new data
                const newPriceCents = parseInt(swatch.getAttribute('data-variant-price'), 10);
                const newCompareAtCents = parseInt(swatch.getAttribute('data-variant-compare-at'), 10);
                if (isNaN(newPriceCents)) return;

                // Update Input for Add To Cart
                if (variantInput) {
                    variantInput.value = newVariantId;
                }

                // Update variant images
                const newPrimaryImage = swatch.getAttribute('data-variant-image') || defaultPrimaryImage;
                const newSecondaryImage = swatch.getAttribute('data-variant-secondary-image') || defaultSecondaryImage;

                if (primaryImage && newPrimaryImage) {
                    primaryImage.src = newPrimaryImage;
                }

                if (secondaryImage) {
                    if (newSecondaryImage) {
                        secondaryImage.src = newSecondaryImage;
                        secondaryImage.style.display = '';
                    } else {
                        secondaryImage.style.display = 'none';
                    }
                }

                // Calculate & Update Prices
                if (priceNow) {
                    if (metafieldDiscountActive && discountValue > 0) {
                        let finalPriceCents = newPriceCents;

                        if (discountType.includes('yüzde') || discountType.includes('%')) {
                            const discountAmount = Math.floor(newPriceCents * discountValue / 100);
                            finalPriceCents = newPriceCents - discountAmount;
                        } else {
                            // Fixed TL discount (convert to cents)
                            const discountAmount = discountValue * 100;
                            finalPriceCents = newPriceCents - discountAmount;
                        }

                        if (finalPriceCents < 0) finalPriceCents = 0;

                        if (priceWas) {
                            priceWas.style.display = 'block';
                            priceWas.textContent = formatMoneyTL(newPriceCents);
                        }
                        priceNow.classList.add('v-has-discount');
                        priceNow.textContent = formatMoneyTL(finalPriceCents);
                        renderDiscountBadge(metafieldBadgeText || null);

                    } else if (!isNaN(newCompareAtCents) && newCompareAtCents > newPriceCents) {
                        // Metafield indirimi yoksa variant compare_at_price kullan
                        const compareDiff = newCompareAtCents - newPriceCents;
                        const comparePercent = Math.round((compareDiff * 100) / newCompareAtCents);

                        if (priceWas) {
                            priceWas.style.display = 'block';
                            priceWas.textContent = formatMoneyTL(newCompareAtCents);
                        }
                        priceNow.classList.add('v-has-discount');
                        priceNow.textContent = formatMoneyTL(newPriceCents);
                        renderDiscountBadge('%' + comparePercent);

                    } else {
                        // No discount state
                        if (priceWas) {
                            priceWas.style.display = 'none';
                        }
                        priceNow.classList.remove('v-has-discount');
                        priceNow.textContent = formatMoneyTL(newPriceCents);
                        renderDiscountBadge(null);
                    }
                }

                if (popup && popup.classList.contains('v-is-open')) {
                    closePopup();
                }
            });
        });
    });
}

// Global scope for cart add intercept (optional, if using AJAX carts)
window.vendensCardAddToCart = function(form) {
    var btn = form.querySelector('.v-card__cart-btn');
    var variantInput = form.querySelector('.v-card__variant-input');
    var variantId = variantInput ? variantInput.value : null;

    if (!variantId || !btn || btn.disabled) return;

    var textSpan = btn.querySelector('.v-card__cart-text');
    var originalText = textSpan ? textSpan.textContent : '';

    btn.disabled = true;
    btn.classList.add('v-is-loading');

    // Spinner CSS pseudo-element ile gösterilecek (DOM sabit kalır)

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    // Drawer düzgün güncellensin diye sections bilgilerini tekrar gönderiyoruz
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        var sections = cartDrawer.getSectionsToRender().map(function(s) { return s.id; });
        if (sections.length) {
            formData.append('sections', sections.join(','));
            formData.append('sections_url', window.location.pathname);
        }
    }

    function restoreButton() {
        btn.classList.remove('v-is-loading');
        btn.disabled = false;
        if (textSpan && originalText) {
            textSpan.textContent = originalText;
        }
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
        credentials: 'same-origin'
    })
    .then(function(res) {
        if (!res.ok) {
            throw new Error('Cart add failed with status ' + res.status);
        }
        return res.json();
    })
    .then(function(response) {
        if (response.status && response.status === 422) throw new Error(response.description);

        // Kullanıcı algısı için butonu hızlıca eski haline al
        restoreButton();

        // Theme Cart Drawer
        if (cartDrawer) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vps-slider', productVariantId: variantId, cartData: response });
            }
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

            // response.sections yoksa renderContents çağrısı yerine drawer aç
            if (response.sections && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(response);
            } else if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
            }
        } else {
            // Fallback: ek cart.js isteği atmadan sayacı optimistik artır
            document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count, #cart-icon-bubble .cart-count, [data-cart-count]').forEach(function(el) {
                var current = parseInt((el.textContent || '0').replace(/\D/g, ''), 10);
                if (isNaN(current)) current = 0;
                el.textContent = current + 1;
                var bubble = el.closest('.cart-count-bubble');
                if (bubble) bubble.classList.remove('hidden');
            });

            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'vps-slider', response: response, optimistic: true } }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
    })
    .catch(function(error) {
        console.error('Error adding to cart:', error);

        restoreButton();

        var errorText = btn.querySelector('.v-card__cart-text');
        if (errorText) {
            var previousText = errorText.textContent;
            errorText.textContent = 'HATA!';
            setTimeout(function() {
                errorText.textContent = previousText;
            }, 1200);
        }
    });
};
